import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CarteraService {

  constructor(
    private http: HttpClient
  ) { }

  ObtenerCartera(filtroFechas) {
    return this.http.post<any>(`${environment.config.apiUrl}arcus/reporte_cartera`, filtroFechas).toPromise();
  }
}
